var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    x: 0,
    y: 0,
    viewBox: "0 0 61 60",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.942 38.574a3.213 3.213 0 0 0-1.921 1.649c-.906 1.567-1.509 4.55-.486 8.222a1 1 0 1 0 1.927-.537 9.2 9.2 0 0 1 .291-6.685c.138-.31.381-.563.687-.711a1 1 0 1 0-.5-1.938zM24.5 36a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zm0-5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z",
    fill: "#ffe082",
    opacity: 1,
    "data-original": "#ffe082"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 11,
    r: 1,
    fill: "#ffe082",
    opacity: 1,
    "data-original": "#ffe082"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 40,
    r: 1,
    fill: "#ffe082",
    opacity: 1,
    "data-original": "#ffe082"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 45,
    r: 1,
    fill: "#ffe082",
    opacity: 1,
    "data-original": "#ffe082"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 14,
    r: 1,
    fill: "#ffe082",
    opacity: 1,
    "data-original": "#ffe082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.614 53.182 46.357 39.924l2.627-23.595A3 3 0 0 0 46 13h-4.782l1.612-4.36 9.743-6.821A1 1 0 0 0 51.427.181l-10 7a1 1 0 0 0-.365.472L39.086 13h-16.8a16.161 16.161 0 0 0-3.36-5.9 6.942 6.942 0 0 0-2.915-1.74c.47-1.01.728-2.107.756-3.221a2 2 0 0 0-.58-1.485A1.972 1.972 0 0 0 14.7.072 6.886 6.886 0 0 0 10.092 1.8a6.206 6.206 0 0 0-1.6 3.413C5.8 2.792 4.464 2.566 4.082 2.566a1.034 1.034 0 0 0-1.041 1 .965.965 0 0 0 .959 1c.011 0 .934.167 3.024 2.018a6.143 6.143 0 0 0-3.3 1.582A6.873 6.873 0 0 0 2 12.771a1.991 1.991 0 0 0 1.991 2.07h.077a8.135 8.135 0 0 0 3.222-.756A6.862 6.862 0 0 0 9.033 17a16.363 16.363 0 0 0 6.45 3.53l1.05 9.445a8.058 8.058 0 0 0-1.773 1.812 4.923 4.923 0 0 0-.366-.391 7.808 7.808 0 0 0-3.48-1.806c-1.835-.453-4.862-.018-7.077.43a1.67 1.67 0 0 0-.75 2.91 35.506 35.506 0 0 0 2.444 1.907 7.22 7.22 0 0 0-3.973 3.383c-1.7 2.944-2.032 7.168-.881 11.3C2.4 55.668 6.936 60 11.306 60a6.364 6.364 0 0 0 2.68-.589c.35.162.714.293 1.087.389a7.415 7.415 0 0 0 5.289-.77c.565.618 1.363.97 2.2.971H41.44a3.01 3.01 0 0 0 2.181-.95c1.732.626 3.559.947 5.4.95h.057a15.928 15.928 0 0 0 10.415-3.869c.429-.37.685-.902.707-1.468a1.972 1.972 0 0 0-.581-1.481zM46.592 42.988l-7.544-.009a9.91 9.91 0 0 1 2.2-5.336zm.006 2-5.332 5.332a9.982 9.982 0 0 1-2.22-5.341zm1.414 1.412.01 7.552a9.988 9.988 0 0 1-5.342-2.22zm2.01 7.551-.01-7.545 5.345 5.345a9.921 9.921 0 0 1-5.335 2.202zM46 15a1.007 1.007 0 0 1 1 1.109l-.746 6.7-2.707 1.356a8 8 0 0 1-6.539.237L40.479 15zm-10.844 8.635A9.976 9.976 0 0 0 32 23.11a9.858 9.858 0 0 0-4.447 1.045 7.985 7.985 0 0 1-7.106 0l-2.7-1.349L17 16.11A1.006 1.006 0 0 1 18 15h20.347zM11.506 3.213a5.142 5.142 0 0 1 3.264-1.15 5.091 5.091 0 0 1-1.143 3.272 5 5 0 0 1-3.263 1.142 5 5 0 0 1 1.142-3.264zM4 12.84a5.082 5.082 0 0 1 1.142-3.263A4.993 4.993 0 0 1 8.4 8.436 5.019 5.019 0 0 1 7.264 11.7 5.076 5.076 0 0 1 4 12.84zm6.444 2.74a4.881 4.881 0 0 1-1.394-2.889 7.352 7.352 0 0 0 1.35-4.218 7.362 7.362 0 0 0 4.2-1.355c1.1.127 2.124.62 2.908 1.4A13.788 13.788 0 0 1 20.167 13H18a3 3 0 0 0-2.984 3.33l.225 2.021a13.969 13.969 0 0 1-4.797-2.771zm6.364 16.858.316 2.843c-.387.18-.762.382-1.124.608a3.636 3.636 0 0 1-.874.4 7.355 7.355 0 0 1 1.682-3.851zm-6.375-.91a5.885 5.885 0 0 1 2.58 1.312c.382.277.605.722.6 1.194l-.009.03c-.091.314-.49.6-1.081.769a5.886 5.886 0 0 1-2.895-.045 15 15 0 0 1-4.712-2.942 15.56 15.56 0 0 1 5.517-.318zm5.134 26.333c-.38-.1-.746-.249-1.088-.443a1 1 0 0 0-.968-.006c-.35.196-.722.346-1.109.449-3.763.962-8.159-3.019-9.8-8.88-1.01-3.623-.753-7.272.686-9.76a5.183 5.183 0 0 1 3.164-2.583 5 5 0 0 1 3.155.272c.445.18.873.4 1.277.66.64.407 1.353.682 2.1.809v1.611a1 1 0 0 0 2 0v-1.611a5.656 5.656 0 0 0 2.084-.8c.094-.059.191-.107.287-.162l2.2 19.782a5.421 5.421 0 0 1-3.988.662zM22.56 58a1 1 0 0 1-1-.891l-3.548-31.935 1.541.77a9.987 9.987 0 0 0 8.894 0 8.076 8.076 0 0 1 6.015-.433l-10.4 28.142a1 1 0 1 0 1.876.694l10.374-28.071a9.944 9.944 0 0 0 8.126-.323l1.549-.776-1.441 12.936-4.727-4.727a2.071 2.071 0 0 0-1.481-.583 2.047 2.047 0 0 0-1.469.708c-5.46 6.366-5.098 15.863.831 21.794A16.092 16.092 0 0 0 41.28 58zm35.621-3.383A14 14 0 0 1 49.027 58h-.007a13.968 13.968 0 0 1-5.34-1.052h-.02A14.047 14.047 0 0 1 38.4 34.8l1.428 1.428a11.944 11.944 0 0 0-2.839 7.747c.013 6.64 5.393 12.02 12.033 12.032a11.949 11.949 0 0 0 7.748-2.839z",
    fill: "#ffe082",
    opacity: 1,
    "data-original": "#ffe082"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinks);
export default __webpack_public_path__ + "static/media/drinks.f3313d1a84d33463fcd7b6c46a8ababb.svg";
export { ForwardRef as ReactComponent };